import { useEffect, useState } from "react";

export default function IntakeTransitionOverlay() {
  const [active, setActive] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setActive(false), 550);
    return () => clearTimeout(t);
  }, []);

  if (!active) return null;

  return (
    <div className="fixed inset-0 z-40 pointer-events-none" aria-hidden="true">
      <div
        className="absolute inset-0"
        style={{
          animation:
            "intakeOverlayFlash 0.55s cubic-bezier(0.4, 0, 0.2, 1) forwards",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-primary-500/[0.05] via-accent-500/[0.03] to-primary-500/[0.05]" />
      </div>
    </div>
  );
}
